module.exports = __webpack_public_path__ + "img/mfd_in_2_inp3.82cc7964.png";